import {
    MODULE_LIST, MODULE_LIST_FILTER_UPDATE, MODULE_LIST_PAGE_UPDATE, MODULE_EDIT_METAINFO,
    MODULE_LIST_SORT, MODULE_PAGE_PREVIEW, UPDATE_MODULE_DATA, SAVE_MODULE,
    SAVE_MODULE_QUESTIONS,
    FETCH_SURVEY_RESPONSE,
    DELETE_MODULE,
    USER_ASSIGNED_COUNTRY_LIST,
    GET_QUESTION_VERSIONS,
    UNMOUNT_PREVIEW_RESPONSE,
    UNMOUNT_MODULE_LIST_RESPONSE,
    MODULE_LIST_BY_SURVEY,
    FETCH_SURVEY_RESPONSE_OFFLINE,
    SYNC_SURVEY_RESPONSE_OFFLINE,
    SET_OFFLINE_MODE,
    SYNC_SURVEY_RESPONSE_OFFLINE_COMPLETED,
    SET_SURVEY_RESPONSE_OFFLINE,
    SAVE_MODULE_RESPONSE,
    APPROVE_QUESTION
} from '../constants/constants';
import { AdminQuestionStatus } from '../constants/Enum/ModuleEnum';


export const modeuleList = () => {
    return {
        type: MODULE_LIST
    }
}

export const modeuleListBySurveyId = (data: any) => {
    return {
        type: MODULE_LIST_BY_SURVEY,
        payload: data
    }
}

export const filterModuleList = (data: any) => {
    return {
        type: MODULE_LIST_FILTER_UPDATE,
        payload: data
    }
}

export const pageModuleList = (data: any) => {
    return {
        type: MODULE_LIST_PAGE_UPDATE,
        payload: data
    }
}

export const sortModuleList = (data: any) => {
    return {
        type: MODULE_LIST_SORT,
        payload: data
    }
}


export const getEditModuleMetadata = (data: any) => {
    return {
        type: MODULE_EDIT_METAINFO,
        payload: data
    }
}


export const updateModule = (data: any) => {
    return {
        payload: data,
        type: UPDATE_MODULE_DATA
    }
}

export const getModulePreview = (data: any) => {
    return {
        type: MODULE_PAGE_PREVIEW,
        payload: data
    }
}

export const saveModule = () => {
    return {
        type: SAVE_MODULE
    }
}

export const saveQuestions = () => {
    return {
        type: SAVE_MODULE_QUESTIONS,
    }
}

export const getSurveyResponse = (data: any) => {
    return {
        type: FETCH_SURVEY_RESPONSE,
        payload: data
    }
}

export const getSurveyResponseOffline = (data: any) => {
    return {
        type: FETCH_SURVEY_RESPONSE_OFFLINE,
        payload: data
    }
}

export const setSurveyResponseOffline = (data: any) => {
    return {
        type: SET_SURVEY_RESPONSE_OFFLINE,
        payload: data
    }
}

export const setSurveyOfflineModeAction = (data: any) => {
    return {
        type: SET_OFFLINE_MODE,
        payload: data
    }
}

export const syncOfflineResponse = (data: any) => {
    return {
        type: SYNC_SURVEY_RESPONSE_OFFLINE,
        payload: data
    }
}

export const syncOfflineCompleted = () => {
    return {
        type: SYNC_SURVEY_RESPONSE_OFFLINE_COMPLETED
    }
}

export const deleteModule = (data: any) => {
    return {
        type: DELETE_MODULE,
        payload: data
    }
}

export const getQuestionsWithAllVersion = (data: any) => {
    return {
        type: GET_QUESTION_VERSIONS,
        payload: data
    }
}

export const getCountriesAssignedToUser = () => {
    return {
        type: USER_ASSIGNED_COUNTRY_LIST
    }
}

export const unmountPreviewResponse = (data: any) => {
    return {
        type: UNMOUNT_PREVIEW_RESPONSE,
        payload: data
    }
}

export const unmountModuleListResponse = (data: any) => {
    return {
        type: UNMOUNT_MODULE_LIST_RESPONSE,
        payload: data
    }
}

export const saveModuleResponse = (data: any) => {
    return {
        type: SAVE_MODULE_RESPONSE,
        payload: data
    }
}

// approve questions
export const approveQuestion = (data: any, adminQuestionStatus: AdminQuestionStatus) => {
    return {
        type: APPROVE_QUESTION,
        payload: data,
        adminQuestionStatus
    }
}






// WEBPACK FOOTER //
// ./src/actions/action.module.tsx